import axios from 'axios';

import { buildLoginPathWithRedirect } from './safeRedirect';

export const apiBaseUrl = `${process?.env?.REACT_APP_BACKEND_URL}`;
export const apiVersion = process?.env?.REACT_APP_BACKEND_URL_VERSION
  ? `${process?.env?.REACT_APP_BACKEND_URL_VERSION}`
  : 'v1';

const headers = {
  'Content-Type': 'application/json',
};

const http = axios.create({
  baseURL: `${apiBaseUrl}/api/${apiVersion}`,
  headers,
});

http.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

const storeKeyToken = 'x-access-token';
const storeKeyUser = 'x-access-user';
const storeKeyTokenExpires = 'x-access-token-expires';
let sessionRedirectInFlight = false;

http?.interceptors?.response?.use(
  (response) => response,
  async (error) => {
    if ([401, 403].includes(error?.response?.status)) {
      localStorage?.removeItem(storeKeyToken);
      localStorage?.removeItem(storeKeyUser);
      localStorage?.removeItem(storeKeyTokenExpires);
      if (!sessionRedirectInFlight) {
        sessionRedirectInFlight = true;
        const attempted = `${window?.location?.pathname || ''}${window?.location?.search || ''}`;
        window?.location?.replace(buildLoginPathWithRedirect(attempted));
      }
    }
    throw error;
  },
);

export const isRequestCanceled = (error: any) => axios.isCancel(error) || error?.code === 'ERR_CANCELED';

export default http;
